// Localização: ./src/App.js (Versão 0.2.1 - Google Analytics - Fix)

import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import AppRoutes from './Routes.js';
import { AuthProvider } from './context/AuthContext';
import { PermissionProvider } from './context/PermissionContext';
import { SidebarProvider } from './context/SidebarContext';
import { SearchProvider } from './context/SearchContext';
import { NotificationProvider } from './context/NotificationContext';
import ToastNotification from './components/UI/ToastNotification';

// 🛑 NOVAS IMPORTAÇÕES DO TANSTACK QUERY
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
// import { ReactQueryDevtools } from '@tanstack/react-query-devtools'; // Opcional

// 🛑 STRIPE: Importar Elements provider
import { Elements } from '@stripe/react-stripe-js';
import stripePromise from './utils/stripeConfig';

// 🛑 GOOGLE ANALYTICS: Importar wrapper
import AnalyticsWrapper from './components/AnalyticsWrapper';

// 🛑 WEB VITALS: Importar utilitário de performance (opcional - requer web-vitals package)
// import { onCLS, onFID, onFCP, onLCP, onTTFB } from 'web-vitals';
// import { reportWebVital } from './utils/performance/webVitals';

// Tratar erro na promise do Stripe
stripePromise.catch((error) => {
    console.error('[App] ❌ Erro ao carregar Stripe:', error.message);
    console.error('[App] 💡 Verifique se as variáveis de ambiente estão configuradas:');
    console.error('[App]    - Desenvolvimento: REACT_APP_STRIPE_TEST_PUBLIC_KEY');
    console.error('[App]    - Produção: REACT_APP_STRIPE_PUBLIC_KEY');
    console.error('[App] ⚠️ IMPORTANTE: Em produção, as variáveis REACT_APP_* devem estar configuradas no momento do BUILD');
    console.error('[App]    Se você alterou o .env após o build, faça um novo build: npm run build');
});

// 1. Crie uma instância global do QueryClient
const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 1000 * 60 * 5, // Dados serão considerados "frescos" por 5 minutos
            refetchOnWindowFocus: false, // Opcional: evita refetchs ao trocar de aba
        },
    },
});

function App() {
    // Inicializar Web Vitals (descomente quando instalar web-vitals)
    // React.useEffect(() => {
    //     onCLS(reportWebVital);
    //     onFID(reportWebVital);
    //     onFCP(reportWebVital);
    //     onLCP(reportWebVital);
    //     onTTFB(reportWebVital);
    // }, []);

    return (
        // 🛑 2. ENVOLVA TUDO COM O PROVIDER DO TANSTACK QUERY
        <QueryClientProvider client={queryClient}>
            {/* 🛑 STRIPE: Elements provider para componentes Stripe */}
            <Elements stripe={stripePromise}>
                <BrowserRouter>
                    {/* 🛑 GOOGLE ANALYTICS: Wrapper para inicializar e rastrear dentro do Router */}
                    <AnalyticsWrapper>
                        <AuthProvider>
                            <PermissionProvider>
                                <SidebarProvider>
                                    <SearchProvider>
                                        <NotificationProvider>
                                            <AppRoutes />
                                            <ToastNotification />
                                        </NotificationProvider>
                                    </SearchProvider>
                                </SidebarProvider>
                            </PermissionProvider>
                        </AuthProvider>
                    </AnalyticsWrapper>
                </BrowserRouter>
            </Elements>
            {/* Opcional: <ReactQueryDevtools initialIsOpen={false} /> */}
        </QueryClientProvider>
    );
}

export default App;